import { Platform } from 'react-native';

export interface StoredPreviewSession {
  sessionId: string;
  signedWsUrl: string;
  agentConvaiId: string;
  expiresAt: string;
  transcript?: Array<{ speaker: 'agent' | 'lead'; text: string; isFinal: boolean }>;
  toolCallLog?: Array<{
    id: string;
    name: string;
    args: unknown;
    result: unknown;
    timestamp: string;
  }>;
}

function storageKey(agentId: string): string {
  return `flowsoft_preview_session_${agentId}`;
}

export function savePreviewSession(agentId: string, data: StoredPreviewSession): void {
  if (Platform.OS !== 'web') return;
  try {
    localStorage.setItem(storageKey(agentId), JSON.stringify(data));
  } catch {}
}

export function loadPreviewSession(agentId: string): StoredPreviewSession | null {
  if (Platform.OS !== 'web') return null;
  try {
    const raw = localStorage.getItem(storageKey(agentId));
    if (!raw) return null;

    const parsed = JSON.parse(raw) as StoredPreviewSession;

    if (new Date(parsed.expiresAt) < new Date()) {
      clearPreviewSession(agentId);
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function clearPreviewSession(agentId: string): void {
  if (Platform.OS !== 'web') return;
  try {
    localStorage.removeItem(storageKey(agentId));
  } catch {}
}
